import { render, staticRenderFns } from "./VerDetalleFuncionesGlobales.vue?vue&type=template&id=0864a7e7&"
import script from "./VerDetalleFuncionesGlobales.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleFuncionesGlobales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0864a7e7', component.options)
    } else {
      api.reload('0864a7e7', component.options)
    }
    module.hot.accept("./VerDetalleFuncionesGlobales.vue?vue&type=template&id=0864a7e7&", function () {
      api.rerender('0864a7e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/FuncionesGlobales/VerDetalleFuncionesGlobales.vue"
export default component.exports